const finite = (value) => value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));

// Revenue and cost of the same days only, so the margin compares like with like.
export function summarizeEconomics(days = []) {
  const sample = days.filter((day) => day?.hasDispatch && finite(day.plannedRevenueCad) && finite(day.realCostCad));
  if (!sample.length) return null;
  const sum = (valueOf) => sample.reduce((total, day) => total + (Number(valueOf(day)) || 0), 0);
  const count = sample.length;
  const revenue = sum((day) => day.plannedRevenueCad);
  const cost = sum((day) => day.realCostCad);
  const hours = sum((day) => day.missionMinutes) / 60;
  const tonnage = sum((day) => day.plannedTonnageTons);
  return {
    dayCount: count,
    revenuePerDispatch: revenue / count,
    hourlyPerDispatch: sum((day) => day.plannedRevenueHourlyCad) / count,
    supplementsPerDispatch: sum((day) => day.plannedRevenueSupplementsCad) / count,
    fixedPerDispatch: sum((day) => day.plannedRevenueFixedCad) / count,
    costPerDispatch: cost / count,
    marginPerDispatch: (revenue - cost) / count,
    marginPct: revenue > 0 ? (revenue - cost) / revenue * 100 : null,
    marginPerHour: hours > 0 ? (revenue - cost) / hours : null,
    // Share of the tons with a rate, weighted by each day's tonnage.
    coveragePct: tonnage > 0 ? sum((day) => (Number(day.revenueCoveragePct) || 0) * (Number(day.plannedTonnageTons) || 0)) / tonnage : null,
    ordersWithoutRate: sum((day) => day.ordersWithoutRate),
  };
}

export const isPartialRevenue = (summary) => Boolean(summary) && (summary.ordersWithoutRate > 0 || (summary.coveragePct ?? 100) < 99.95);
